import React from 'react';
import PropTypes from 'prop-types';

export function RenderMark(type, Component) {
  return {
    renderMark(props, editor, next) {
      if (type === props.mark.type) {
        return <Component {...props} />;
      }
      return next();
    },
  };
}

RenderMark.propTypes = {
  type: PropTypes.string,
  Component: PropTypes.node,
};
